module.exports = __webpack_public_path__ + "images/harmonie-0dfc5ebbe829d04635958ef26132fd30.jpg";